import React, { useEffect, useCallback, useState} from 'react';
import {PALETTE_COLORS} from 'constants/palette-colors.js';
import {connect} from 'react-redux';
import {
    updateStepParameter
} from 'operations/actions.js';

const PaletteChooser = ({effect, stepData}) => { 
    let [selectedPalette, setSelectedPalette] = useState(stepData.palette);
    let sequencerEngine = effect.track.sequencerEngine;
    
    const onChoosePalette = useCallback((palette) => {
        sequencerEngine.operationManager.dispatch(
            updateStepParameter(
                effect.track,
                stepData,
                stepData.paletteParameter,
                palette));
        setSelectedPalette(palette);
    }, [setSelectedPalette, stepData]);
    
    return (
        <div className="palettes-container">
          {effect.palettes.map(
              palette =>
                  <PaletteOption
                    onChoosePalette={onChoosePalette}
                    palette={palette}
                    selectedPalette={selectedPalette}/>)}
        </div>
    );
}

const PaletteOption = ({palette, selectedPalette, onChoosePalette}) => {
    let className = "palette-option";
    if (palette === selectedPalette) {
        className += " selected";
    }
    let style = {
        backgroundColor: PALETTE_COLORS[palette]
    };
    return (
        <div
          style={style}
          onClick={() => onChoosePalette(palette === selectedPalette ? undefined : palette)}
          className={className}>
          {palette + 1}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaletteChooser);
